"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryPickerMobile = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _MobileDropdown = require("../MobileDropdown");
var _PriorityCountries = require("./Mobile/PriorityCountries.mobile");
var _SearchInput = require("./Mobile/SearchInput.mobile");
var _OptionList = require("./Mobile/OptionList.mobile");
var _AutocompleteList = require("./Mobile/AutocompleteList.mobile");
var _Flags = require("../Flags/Flags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:
// Interfaces:
// Icons:
var Plane = function Plane(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "#17181A",
    d: "M10.937 12.507l-3.323 2.038s-.882.686-2.545.343c-1.664-.343-3.37-.72-3.37-.72s-.365-.133-.618.194c-.252.326.163.521.163.521l2.566 1.858s.547.542 1.353.4c.805-.142 3.175-.623 3.175-.623s1.617-.346 3.54-1.545c1.924-1.2 8.8-5.372 8.8-5.372s2.675-1.521 2.407-2.158c-.268-.636-1.811-.466-2.549-.233-.737.233-6.494 3.496-6.494 3.496l-6.31-2.163s-.816-.194-.408.282c.408.477 4.406 4.456 4.406 4.456m1.564 2.263l1.714 1.71s.498.394.598-.979c.1-1.372.202-2.4.202-2.4"
  }));
};
Plane.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}; // Flags:
var CountryPickerMobile = exports.CountryPickerMobile = function CountryPickerMobile(props) {
  var onChangeCountry = props.onChangeCountry,
    autocompleteOptions = props.autocompleteOptions,
    availableCountries = props.availableCountries,
    priorityCountries = props.priorityCountries,
    currentCountry = props.currentCountry,
    onInputChange = props.onInputChange,
    inputValue = props.inputValue;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var label = 'Куда';
  var placeholder = 'Страна, курорт или отель';
  var showAutocomplete = Boolean(inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim());
  var hasCountries = !(0, _isEmpty2["default"])(availableCountries) && !(0, _isEmpty2["default"])(priorityCountries);
  var handleCancel = function handleCancel() {
    return setIsOpen(false);
  };
  var handleControlClick = function handleControlClick() {
    return setIsOpen(true);
  };
  var handleChoose = function handleChoose(val) {
    onChangeCountry(val);
    setIsOpen(false);
  };
  var handleInputChange = function handleInputChange(event) {
    return onInputChange(event.target.value);
  };
  return /*#__PURE__*/_react["default"].createElement(_MobileDropdown.MobileDropdown, {
    onCancel: handleCancel,
    onControlClick: handleControlClick,
    popupLabel: label,
    dropdownLabel: currentCountry.name_ru,
    open: isOpen,
    submitButtonText: "",
    containerStyles: ContainerStyles,
    fullControl: true
  }, hasCountries ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SearchInput.SearchInputMobile, {
    value: inputValue,
    onChange: handleInputChange,
    placeholder: placeholder
  }), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, !showAutocomplete ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_PriorityCountries.PriorityCountriesMobile, {
    countries: priorityCountries,
    onClickDestination: handleChoose
  }), /*#__PURE__*/_react["default"].createElement(_OptionList.OptionListMobile, {
    label: "\u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u0442\u0440\u0430\u043D\u044B",
    countries: availableCountries,
    onClickDestination: handleChoose
  })) : null, showAutocomplete && /*#__PURE__*/_react["default"].createElement(_AutocompleteList.AutocompleteMobile, {
    onChoose: handleChoose,
    autocompleteOptions: autocompleteOptions
  }))) : /*#__PURE__*/_react["default"].createElement(StyledEmpty, null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(StyledIconPlane, null)), "\u041D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043D\u0435\u0442 \u0432\u044B\u043B\u0435\u0442\u043E\u0432 \u043D\u0438 \u0432 \u043E\u0434\u043D\u0443 \u0441\u0442\u0440\u0430\u043D\u0443. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043C\u0435\u043D\u0438\u0442\u044C \u0433\u043E\u0440\u043E\u0434 \u0432\u044B\u043B\u0435\u0442\u0430 \u043D\u0430 \u041C\u043E\u0441\u043A\u0432\u0443 \u0438\u043B\u0438 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0439 \u043A \u0432\u0430\u043C \u0433\u043E\u0440\u043E\u0434 \u0441 \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u043E\u043C"));
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CountryPickermobile__StyledWrapper",
  componentId: "sc-k7abtv-0"
})(["margin-top:60px;", ""], (0, _Flags.flagSprite)());
var ContainerStyles = (0, _styledComponents.css)(["padding:0 8px;&:after{height:50px;bottom:0;content:'';width:100%;position:fixed;background:linear-gradient( 180deg,rgba(255,255,255,0) 0%,#ffffff 100% );}"]);
var StyledEmpty = _styledComponents["default"].div.withConfig({
  displayName: "CountryPickermobile__StyledEmpty",
  componentId: "sc-k7abtv-1"
})(["height:400px;margin:auto;padding:0 62px;padding-top:100px;text-align:center;font-size:16px;line-height:20px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.coolGrey;
});
var StyledIconPlane = (0, _styledComponents["default"])(Plane).withConfig({
  displayName: "CountryPickermobile__StyledIconPlane",
  componentId: "sc-k7abtv-2"
})(["fill:none;width:100px;"]);